import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import Popper from "@material-ui/core/Popper";

// @material-ui/icons
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";

import FilterSearchModal from "../../views/Dashboard/FilterSearchModal";
import { useAuth } from "../../context/AuthContext";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  const { rtlActive } = props;

  const [openFilterModal, setOpenFilterModal] = React.useState(false);

  const handleClickFilter = () => {
    setOpenFilterModal(true);
    console.log("Filter button clicked");
  };

  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive,
  });

  const managerClasses = classNames({
    [classes.managerClasses]: true,
  });

  return (
    <div className={wrapper}>
      {/* 🔍 Filter Icon */}
      <div className={managerClasses}>
        <Button
          color="transparent"
          justIcon
          aria-label="Filter"
          onClick={handleClickFilter}
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : "",
          }}
        >
          <TuneOutlinedIcon
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          <Hidden mdUp implementation="css">
            <span onClick={handleClickFilter} className={classes.linkText}>
              {rtlActive ? "تصفية" : "Filter"}
            </span>
          </Hidden>
        </Button>
      </div>

      {/* 🔍 Filter Modal */}
      <FilterSearchModal
        open={openFilterModal}
        onClose={handleCloseFilterModal}
      />
    </div>
  );
}

HeaderLinks.propTypes = {
  rtlActive: PropTypes.bool,
};
